import { render, staticRenderFns } from "./VDropdown.vue?vue&type=template&id=c446acce&lang=pug"
import script from "./VDropdown.vue?vue&type=script&lang=js"
export * from "./VDropdown.vue?vue&type=script&lang=js"
import style0 from "./VDropdown.vue?vue&type=style&index=0&id=c446acce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports